import { KycDetails } from "./component";
import { asConfiguredComponent } from "../../helper/configured-component/configured-component";
import { fetchKycReducer } from "./fetcher";

//STEP: 2 - Import fetcher reducer and pass it to asConfiguredComponent

const Component = asConfiguredComponent([fetchKycReducer], KycDetails);
export default Component;
